import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Auth.scss";
import {
  OutlinedInput,
  TextField,
  InputAdornment,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { industriesService } from "../../services/orgService";
import CloseIcon from "@mui/icons-material/Close";
import {
  getSubscriptionPlans,
  createZohoCustomer,
} from "../../services/subscriptionService";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useDispatch } from "react-redux";
import { setUserName, signUpUser } from "../../actions/authActions";
import { toastMessage } from "../../helper";
import MapsInput from "../common/MapsInput";
import { errorMessage } from "../../constants/messageConstants";
import {
  EMAIL_REGEX,
  STRONG_PASSWORD_REGEX,
} from "../../constants/regexConstants";
import { checkEmailSubstring } from "../../constants/emailConstants";
import { useTranslation } from "react-i18next";
import { Select as AntSelect, Cascader, Input } from "antd";
import {
  Button,
  Checkbox,
  FormControlLabel,
  InputBase,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  styled,
} from "@mui/material";
import { Dialog } from "@material-ui/core";
import { checkGMUser } from "../../services/authService";
const Register = (props: any) => {
  const { t, i18n } = useTranslation();
  const inputStyle = {
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: "green",
      },
    },
  };
  let [openPasswordConfirmation, setOpenPasswordConfirmation] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const accountTypes = ["Corporate", "Trainer"];
  const [accountType, setAccountType] = useState(
    queryParams.get("accountType") === "trainer" ? "Trainer" : "Corporate"
  );
  const [allPlans, setAllPlans] = useState([] as any);
  const [planId, setPlanId] = useState("");
  const [planName, setPlanName] = useState("");
  const [planCode, setPlanCode] = useState(queryParams.get("plan") || "");
  const [industries, setIndustries] = useState([]);
  useEffect(() => {
    fetchIndustryData();
  }, []);
  const [formData, setFormData] = useState({
    email: "",
    code: "",
    company: "",
    industry: "",
    password: "",
    privacyPolicy: false,
    servicePolicy: false,
    planId: "",
    planCode: "",
    address: {
      addressLine1: "",
      addressLine2: "",
      city: "",
      cityCode: "",
      state: "",
      stateCode: "",
      country: "",
      countryCode: "",
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
  });
  const [errorData, setErrorData] = useState({
    emailError: "",
    passwordError: "",
    codeError: "",
    addressError: "",
  });
  const { Option } = AntSelect;
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [address, setAddress] = useState("");
  const {
    company,
    email,
    password,
    industry,
    privacyPolicy,
    servicePolicy,
    code,
  } = formData;
  const { emailError, codeError, passwordError, addressError } = errorData;

  // const onChange = (e:any) =>{
  //     if (e.target.name === "privacyPolicy" ||e.target.name === "servicePolicy") {
  //       setFormData((prevState)=>{return { ...prevState, [e.target.name]: e.target.checked }});
  //     } else{
  //       setFormData((prevState)=>{return { ...prevState, [e.target.name]: e.target.value }});
  //     }
  //     validateFields({name:e.target.name,target:e.target.value});
  //     console.log("form- data ",formData);

  //   }
  const onChange = (e: any) => {
    validateFields(e.target.name, e.target.value);
    if (
      e.target.name === "privacyPolicy" ||
      e.target.name === "servicePolicy"
    ) {
      setFormData({ ...formData, [e.target.name]: e.target.checked });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  let [isGMUserExists, setIsGMUserExists] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const navigateToVerifyAccount = () => {
    // 👇️ navigate to /contacts
    navigate("/verifyotp", { state: { username: 1, password: password } });
  };
  const fetchIndustryData = async () => {
    const indusRes = await industriesService();
    setIndustries(indusRes.data);
    setFormData({ ...formData, industry: indusRes.data[0].name });
    console.log("after industries form data", formData);
  };

  const onSubmit = async (e: any) => {
    e.preventDefault();
    console.log("submittng ", formData);
    const lowerCaseEmail = email.toLocaleLowerCase();
    if (validateForm()) {
      checkGMUser(lowerCaseEmail)
        .then((res) => {
          setIsGMUserExists(res.data);
          setOpenPasswordConfirmation(res.data);
          if (!res.data) {
            signUp(false);
          }
        })
        .catch((err) => {
          toastMessage(err?.response?.data?.message, "error");
        });
    }
  };

  const handleAccountTypeChange = (type: string) => {
    setAccountType(type);
  };

  const signUp = async (updatePassword: boolean) => {
    setOpenPasswordConfirmation(false);
    const lowerCaseEmail = email.toLocaleLowerCase();
    setIsLoading(true);
    signUpUser(
      company,
      industry,
      lowerCaseEmail,
      password,
      code,
      accountType.toLocaleUpperCase(),
      planId,
      planCode,
      formData.address,
      updatePassword
    )
      .then((res) => {
        if (res?.data) {
          createZohoCustomer({
            email: res?.data?.user?.username,
            companyName: res?.data?.companyName,
            companyId: res?.data?.company,
            planId,
            planCode,
            user: res?.data?.user?.id,
          }).then((zohoRes) => {
            dispatch(setUserName(lowerCaseEmail));
            localStorage.setItem("userName", lowerCaseEmail);
            localStorage.setItem("accountType", accountType);
            if (isGMUserExists) {
              navigate("/coorporate-onboarding");
            } else {
              navigateToVerifyAccount();
            }
            setIsLoading(false);
          });
        }
      })
      .catch((err) => {
        setIsLoading(false);
        toastMessage(err?.response?.data?.message, "error");
        console.log(
          "Error:",
          err.response && err.response.data && err.response.data.message
        );
      });
  };

  const validateFields = (name: string, value: string) => {
    if (name === "email") {
      setErrorData({ ...errorData, emailError: "" });
      //regex mail
      if (!EMAIL_REGEX.test(value)) {
        //setErrorData((prevState)=>{return {...prevState,emailError: "Invalid Email"}});
        setErrorData({ ...errorData, emailError: "Invalid Email" });
      } else if (checkEmailSubstring(value)) {
        setErrorData({
          ...errorData,
          emailError:
            "Registration in the UI is only supported for company emails. To register and use the application, please provide your details, which are displayed on the current page, to our customer support team at support@planetwise.io",
        });
      }
    }
    if (name === "code") {
      setErrorData({ ...errorData, codeError: "" });
      //regex mail
      if (
        value.length < 3 ||
        value.length > 50 ||
        !value.match("^[a-zA-Z0-9]*$")
      ) {
        setErrorData({
          ...errorData,
          codeError: errorMessage().REGISTRATION_FORMAT,
        });
        //setErrorData((prevState)=>{return {...prevState,codeError: "Registration Id Should be 3 - 20 digit Alphanumeric"}});
      }
    }
  };

  const validatePassword = (password: any) => {
    if (!STRONG_PASSWORD_REGEX.test(password)) {
      return errorMessage().STRONG_PASSWORD_REGEX_ERROR;
    }
    return "true";
  };

  const validateForm = () => {
    return (
      email &&
      !emailError &&
      code &&
      !codeError &&
      industry &&
      company &&
      validatePassword(password) === "true" &&
      privacyPolicy &&
      servicePolicy &&
      // planId &&
      !isLoading &&
      !addressError
    );
  };
  const onChangeAddress = (e: any) => {
    const newForm = { ...formData };
    newForm.address.addressLine1 = e.target.value.addressLine;
    newForm.address.stateCode = e.target.value.stateCode;
    newForm.address.countryCode = e.target.value.countryCode;
    newForm.address.city = e.target.value.city;
    newForm.address.cityCode = e.target.value.cityCode || "";
    newForm.address.state = e.target.value.state;
    newForm.address.country = e.target.value.country;
    setFormData(newForm);
  };

  useEffect(() => {
    getSubscriptionPlans().then((res: any) => {
      if (res?.data?.plans?.length) {
        setAllPlans(res.data.plans);
      }
    });
  }, []);

  useEffect(() => {
    if (allPlans?.length) {
      let currentPlans = allPlans.filter(
        (eachPlan: any) =>
          (accountType === "Trainer") ===
          eachPlan.plan_code.toString().startsWith("t1")
      );
      let selectedPlanIndex = currentPlans.findIndex(
        (eachPlan: any) => eachPlan.plan_code === queryParams.get("plan")
      );
      if (selectedPlanIndex === -1) {
        selectedPlanIndex = currentPlans.findIndex(
          (eachPlan: any) => eachPlan.plan_code === "v1-basic-monthly"
        );
        selectedPlanIndex = selectedPlanIndex > -1 ? selectedPlanIndex : 0;
      }
      setPlanId(currentPlans[selectedPlanIndex].plan_id);
      setPlanCode(currentPlans[selectedPlanIndex].plan_code);
      setPlanName(currentPlans[selectedPlanIndex].name);
    }
  }, [allPlans, accountType]);

  return (
    <>
      <form className="pw-width-100 flex flex-col pw-register-form">
        <div className="">
          <div className="flex flex-row items-center pw-selected-plan pw-input-label !mt-0">
            <div className="flex flex-row items-center w-1/2 pw-input-label">
              <div>Account Type: </div>
              <div>
                <Select
                  className="pw-account-type-selection !text-sm !"
                  onChange={(event) =>
                    handleAccountTypeChange(event.target.value)
                  }
                  value={accountType}
                >
                  {accountTypes.map((eachType: any) => (
                    <MenuItem key={eachType} value={eachType}>
                      {eachType}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </div>
            <div className="flex flex-row items-center gap-2 pw-input-label">
              <div>Selected Plan: </div>
              <div className="text-sm uppercase">{planName}</div>
            </div>
          </div>
        </div>
        <div className="">
          <div className="flex flex-row pw-input-label !gap-0.5 items-center">
            <div>{t("company")}</div>
            <div className="pw-mandatory-icon">*</div>
          </div>
          <TextField
            type="text"
            variant="outlined"
            placeholder={t("company")}
            size="small"
            name="company"
            className="pw-width-100 pw-input-field"
            value={company}
            onChange={(e) => onChange(e)}
          />
        </div>
        <div className="">
          <div className="flex flex-row pw-input-label !gap-0.5 items-center">
            <div>{t("email")}</div>
            <div className="pw-mandatory-icon">*</div>
          </div>
          <TextField
            type="email"
            variant="outlined"
            placeholder={t("email")}
            size="small"
            name="email"
            className="pw-width-100 pw-input-field"
            value={email}
            onChange={(e) => onChange(e)}
          />
          {emailError && (
            <span className="pw-display-error">* {emailError}</span>
          )}
        </div>
        <div className="">
          <div className="flex flex-row pw-input-label !gap-0.5 items-center">
            <div>{t("code")}</div>
            <div className="pw-mandatory-icon">*</div>
          </div>
          <TextField
            type="text"
            variant="outlined"
            placeholder={t("code")}
            size="small"
            name="code"
            className="pw-width-100 pw-input-field"
            value={code}
            onChange={(e) => onChange(e)}
          />
          {codeError ? (
            <span className="pw-display-error">* {t(codeError)}</span>
          ) : (
            ""
          )}
        </div>
        <div className="">
          <div className="flex flex-row pw-input-label !gap-0.5 items-center">
            <div>{t("address")}</div>
            <div className="pw-mandatory-icon">*</div>
          </div>
          <MapsInput
            value={formData?.address?.addressLine1}
            formData={formData}
            isTextArea
            setFormData={setFormData}
            errorData={errorData}
            setErrorData={setErrorData}
            onChange={onChangeAddress}
          />

          {addressError && (
            <span className="pw-display-error">No Address Found</span>
          )}
        </div>
        {/* <div className="">
        <div className="pw-input-label">Industry Type</div>
        <select
          name="industry"
          value={industry}
          className="pw-select"
          onChange={(e) => onChange(e)}
        >
          {industries?.map(({ name, id }, index) => (
            <option key={id} value={name}>
              {name}
            </option>
          ))}
        </select>
      </div> */}
        <div className="">
          <div className="flex flex-row pw-input-label !gap-0.5 items-center">
            <div>{t("password")}</div>
            <div className="pw-mandatory-icon">*</div>
          </div>
          <OutlinedInput
            id="filled-adornment-password"
            type={showPassword ? "text" : "password"}
            name="password"
            size="small"
            sx={inputStyle}
            className="pw-width-100 pw-input-field"
            value={password}
            onChange={(e) => onChange(e)}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onMouseDown={() => {
                    setShowPassword(true);
                  }}
                  onClick={() => {
                    setShowPassword(false);
                  }}
                  edge="end"
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
          />
          {password?.length > 0 && validatePassword(password) !== "true" ? (
            <span className="pw-display-error">
              {t(validatePassword(password))}
            </span>
          ) : (
            ""
          )}
        </div>
        <div className="flex flex-row pw-shift-left-10">
          <Checkbox
            value={privacyPolicy}
            name="privacyPolicy"
            onChange={(e) => onChange(e)}
          />
          <div className="text-sm">
            <span>{t("privacyPolicy")}</span>
            <a
              href="https://planetwise.io/privacy-policy"
              target="_blank"
              rel="noreferrer"
              className="pw-primary-color pw-text-underline font-semibold"
            >
              {t("privacyPolicyLink")}
            </a>
          </div>
        </div>
        <div className="flex flex-row pw-shift-left-10">
          <Checkbox
            value={servicePolicy}
            color="primary"
            name="servicePolicy"
            onChange={(e) => onChange(e)}
          />
          <div className="text-sm">
            <span>{t("servicePolicy")}</span>
            <a
              href="https://planetwise.io/terms-conditions"
              target="_blank"
              rel="noreferrer"
              className="pw-primary-color pw-text-underline font-semibold"
            >
              {t("servicePolicyLink")}
            </a>
          </div>
        </div>
        <button
          type="submit"
          className={`pw-cursor-pointer ${
            validateForm()
              ? isLoading
                ? "pw-neutral-background"
                : "pw-primary-button"
              : "pw-neutral-background"
          }`}
          onClick={(e) => onSubmit(e)}
          disabled={!validateForm()}
        >
          {isLoading ? (
            <div className="flex flex-row gap-2 items-center justify-center">
              <span>{t("Signing Up")}</span>
              <CircularProgress size={20} />
            </div>
          ) : (
            <span>{t("Sign Up")}</span>
          )}
        </button>
      </form>
      <Dialog maxWidth="md" open={openPasswordConfirmation}>
        <div
          style={{ padding: "50px 5vw", width: "70vw", position: "relative" }}
        >
          <CloseIcon
            onClick={(e) => {
              setOpenPasswordConfirmation(false);
            }}
            style={{
              position: "absolute",
              right: "5vw",
              top: "2vh",
              cursor: "pointer",
            }}
          />
          <div>
            <strong style={{ fontSize: "1.3rem" }}>
              User already exists for the Green Mirror.
            </strong>
          </div>
          <br />
          <div>
            User already exists for the Green Mirror. You can't use different
            password for same email id.
          </div>
          <br />
          <div>
            Kindly use the following options
            <ol style={{ listStyleType: "decimal", marginLeft: "16px" }}>
              <li>Use the existing green mirror password</li>
              <li>
                Update to new password. Note the password will be updated for
                both Green Mirror and Planetwise
              </li>
            </ol>
          </div>
        </div>
        <div
          style={{
            boxShadow: "0 0 5px 0px",
            padding: "10px",
            display: "flex",
            justifyContent: "end",
          }}
        >
          <Button
            onClick={(e) => {
              signUp(true);
            }}
            variant="outlined"
            sx={{
              color: "black",
              background: "white",
              fontWeight: "800",
              textTransform: "none",
              marginRight: "15px",
              paddingTop: "10px",
              border: "1px solid rgb(128,128,128)",
            }}
          >
            Update to password
          </Button>
          <Button
            onClick={(e) => {
              signUp(false);
            }}
            variant="contained"
            sx={{ color: "white", fontWeight: "800", textTransform: "none" }}
          >
            Use existing password
          </Button>
        </div>
      </Dialog>
    </>
  );
};
export default Register;
